import { render, staticRenderFns } from "./LayoutGrid.vue?vue&type=template&id=654f3060&scoped=true&"
import script from "./LayoutGrid.vue?vue&type=script&lang=js&"
export * from "./LayoutGrid.vue?vue&type=script&lang=js&"
import style0 from "./LayoutGrid.vue?vue&type=style&index=0&id=654f3060&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654f3060",
  null
  
)

export default component.exports